<template>
  <span>{{ categories[params.value].label }}</span>
</template>
<script>
  import {
    PLOT_CHILD_CATEGORY,
  } from "@/config/const";

  export default {
    name: "CellRendererPlotCategory",
    computed: {},
    data() {
      return {
        // Plot categories
        categories: PLOT_CHILD_CATEGORY.properties
      }
    }
  };
</script>

<style lang="scss" scpoped>

</style>
